import { useTranslation } from 'react-i18next';

import BannerFill from '../../../../../../../../../shared/components/Globals/BannerFill/BannerFill';
import { TRANSLATIONS_QUOTES } from '../../../../../../../../../shared/translations/quotes';

export interface CensusErrorMismatchStepProps {
  mismatchCount: number;
  employeeHeadcount: number;
}

export default function CensusErrorMismatchStep({
  mismatchCount,
  employeeHeadcount
}: Readonly<CensusErrorMismatchStepProps>) {
  const { t } = useTranslation();

  return (
    <div className="census-step">
      <BannerFill
        variant="danger"
        title={t(TRANSLATIONS_QUOTES.create.censusModal.errorMismatchBannerTitle, { hc: employeeHeadcount })}
        description={t(TRANSLATIONS_QUOTES.create.censusModal.errorMismatchDesc, {
          mismatchCount,
          hc: employeeHeadcount
        })}
        screenReaderLabel={t(TRANSLATIONS_QUOTES.create.censusModal.error)}
      />
    </div>
  );
}
